var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"leftInfo"},[_c('div',{staticClass:"title"},[_vm._v(" "+_vm._s(_vm.$t('trade').title)+" ")]),_c('div',{staticClass:"usdt"},[_vm._v(" usdt ")]),_c('div',{staticClass:"scroll"},_vm._l((_vm.productNowInfo),function(item,index){return _c('div',{key:index,staticClass:"item",on:{"click":function($event){return _vm.handleClick(index)}}},[_c('span',[_c('i',[_vm._v(_vm._s(item.EnglishName))]),_vm._v("/USDT")]),_c('span',{style:({
          color:
            item.Price - item.BasicPrice > 0
              ? _vm.basicConfig.RiseColour
              : _vm.basicConfig.FallColour
        })},[_vm._v(_vm._s(item.Price))])])}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }